import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { DrilldownJsonApiResponse } from 'api/normalized/insightDrilldown/InsightDrilldownApi';
import { transformProjectDrilldownData } from 'api/normalized/insightDrilldown/transformers';
import { RootState } from 'state/store';
import { ProjectDrillDownItem } from 'types/store/normalized/insightsDrillDown';
import { JsonApiResource } from 'types/store/jsonApi';
import { ProjectDrillDownApiResponse } from 'api/normalized/insightDrilldown/types';

/* ============================== STATE SETUP =============================== */
const insightDrilldownProjectsAdapter =
  createEntityAdapter<ProjectDrillDownItem>();

/* ================================= REDUCER ================================ */
const insightDrilldownProjectsSlice = createSlice({
  name: 'normalized/insightDrilldownProjects',
  initialState: insightDrilldownProjectsAdapter.getInitialState(),
  reducers: {
    addProjects: (
      state,
      action: PayloadAction<DrilldownJsonApiResponse['data']>
    ) => {
      const projectDrilldowns = transformProjectDrilldownData(
        action.payload as JsonApiResource<ProjectDrillDownApiResponse>[]
      );
      insightDrilldownProjectsAdapter.setMany(state, projectDrilldowns);
    },
  },
});

/* =============================== SELECTORS ================================ */
const defaultSelectors =
  insightDrilldownProjectsAdapter.getSelectors<RootState>(
    (state) => state.normalized.insightDrilldownProjects
  );

const selectProjectsByIds = (
  state: RootState,
  ids: string[]
): ProjectDrillDownItem[] =>
  ids
    .map((id) => defaultSelectors.selectById(state, id))
    .filter((item) => !!item);

/* ================================ EXPORTS ================================= */
export const insightDrilldownProjectsSelectors = {
  ...defaultSelectors,
  selectProjectsByIds,
};
export const { addProjects } = insightDrilldownProjectsSlice.actions;
export default insightDrilldownProjectsSlice.reducer;
